// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"8cbe4c99","232":"113ba6f3","237":"8a900082","526":"18574d1c"}[chunkId] + ".chunk.js";
};